// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "row__serviceHeader__wrapper-9BAYt";
var _3 = "row__serviceHeader-2EMUi";
var _4 = "row__serviceHeader_preferred-83IAg";
var _5 = "row__serviceHeader_comfort-1ju6z";
export { _1 as "__esModule", _2 as "row__serviceHeader__wrapper", _3 as "row__serviceHeader", _4 as "row__serviceHeader_preferred", _5 as "row__serviceHeader_comfort" }
export default { "__esModule": _1, "row__serviceHeader__wrapper": _2, "row__serviceHeader": _3, "row__serviceHeader_preferred": _4, "row__serviceHeader_comfort": _5 }
